import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=59748764&scoped=true"
import script from "./order-table.vue?vue&type=script&lang=js"
export * from "./order-table.vue?vue&type=script&lang=js"
import style0 from "./order-table.vue?vue&type=style&index=0&id=59748764&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59748764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59748764')) {
      api.createRecord('59748764', component.options)
    } else {
      api.reload('59748764', component.options)
    }
    module.hot.accept("./order-table.vue?vue&type=template&id=59748764&scoped=true", function () {
      api.rerender('59748764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Order/order-table.vue"
export default component.exports